import { Trans } from "@lingui/react/macro";
import { Tab } from "@medoma/components/Tabs";
import { NotificationCircle } from "@medoma/components/NotificationCircle/NotificationCircle";
import { useHasUnreadNotifications } from "@medoma/chat/useUnreadNotificationCounts";

export const CommunicationTab = ({ patientId }: { patientId: string }) => {
  const hasUnreadNotification = useHasUnreadNotifications({
    roomName: patientId,
  });
  return (
    <Tab to="communication">
      <NotificationCircle isVisible={hasUnreadNotification} placement="right">
        <Trans>Kommunikation</Trans>
      </NotificationCircle>
    </Tab>
  );
};
